import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["documentType", "generate"]
  static values = { documentType: String }

  connect() {
    if (!this.hasDocumentTypeValue) return

    this.#addDocumentTypeOption()
    this.documentTypeTarget.value = this.documentTypeValue
    this.documentTypeTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.generateTargets.find(({ dataset }) => dataset.documentType === this.documentTypeValue).click()
    this.#completeLaunch()
  }

  #addDocumentTypeOption() {
    const optionExists = Array.from(this.documentTypeTarget.options)
      .some(({ value }) => value === this.documentTypeValue)

    if (optionExists) return

    const option = new Option("", this.documentTypeValue)
    option.hidden = true
    this.documentTypeTarget.add(option)
  }

  #completeLaunch() {
    const url = new URL(window.location.href)
    url.searchParams.delete("ai_document_type")
    window.history.replaceState({}, "", url)
    this.element.removeAttribute("data-ai-document-builder-launcher-document-type-value")
  }
}
